module.exports = __webpack_public_path__ + "static/media/jambon morgh.c6a3e565.png";